import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { GraduationCap, X } from "lucide-react";
import { ENROLL_NAMES, COURSES, PACKAGES } from "@/data/content";

const ITEMS = [...COURSES.map((c) => c.title), ...PACKAGES.map((p) => p.name + " Package")];

export default function RecentEnrollment() {
  const [idx, setIdx] = useState(0);
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const { pathname } = useLocation();
  const hidden = pathname.startsWith("/dashboard") || pathname.startsWith("/admin");

  useEffect(() => {
    if (dismissed) return;
    const first = setTimeout(() => setShow(true), 4000);
    const loop = setInterval(() => {
      setShow(false);
      setTimeout(() => { setIdx((i) => i + 1); setShow(true); }, 700);
    }, 9000);
    return () => { clearTimeout(first); clearInterval(loop); };
  }, [dismissed]);

  const [name, city] = ENROLL_NAMES[idx % ENROLL_NAMES.length];
  const item = ITEMS[(idx * 3) % ITEMS.length];
  const mins = 2 + ((idx * 7) % 25);

  return (
    <AnimatePresence>
      {show && !dismissed && !hidden && (
        <motion.div data-testid="recent-enrollment-popup" initial={{ opacity: 0, y: 30, scale: 0.95 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 20 }}
          className="glass pulse-glow fixed bottom-20 sm:bottom-5 right-5 z-30 rounded-2xl p-4 pr-10 flex items-center gap-3 max-w-[300px]">
          <div className="icon-orb !w-11 !h-11 shrink-0"><GraduationCap size={20} /></div>
          <div className="text-xs leading-snug">
            <p className="text-[var(--muted)]">Recent Enrollment</p>
            <p className="font-semibold mt-0.5"><span className="text-[var(--pink)]">{name}</span> from {city} joined <b>{item}</b></p>
            <p className="text-[var(--muted)] mt-0.5">{mins} min ago</p>
          </div>
          <button data-testid="recent-enrollment-close" onClick={() => setDismissed(true)} className="absolute top-2 right-2 text-[var(--muted)] hover:text-[var(--pink)]"><X size={14} /></button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
